// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bso2","right":"Footer_right__2ImeG","buttons":"Footer_buttons__2YLkS"};